// extracted by mini-css-extract-plugin
export default {"main":"style_main__4ul14","wb":"style_wb__jmNEv","sub":"style_sub__kMgl2"};